import React from 'react';

import PWInput from 'components/form/password_input';

type Props = {
  initialValue?: string;
  inputName: string;
  pattern: string;
}

export default function PasswordInput({ initialValue, inputName, pattern }: Props) {
  const [val, setVal] = React.useState(initialValue || '');

  return (
    <PWInput inputName={inputName} pattern={pattern} value={val} onChange={setVal}/>
  );
}
